// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aggregated-table-root {
  margin: 2rem 0;
}
.aggregated-table-root table {
  border: 1px solid lightgray;
}
.aggregated-table-root tbody {
  border-bottom: 1px solid lightgray;
}
.aggregated-table-root tbody tr {
  border-bottom: 1px solid lightgray;
}
.aggregated-table-root tbody tr td {
  border-right: 1px solid lightgray;
  padding: 0.25rem;
}
.aggregated-table-root th {
  border-bottom: 1px solid lightgray;
  border-right: 1px solid lightgray;
  padding: 2px 4px;
  font-weight: 700;
}
.aggregated-table-root tfoot th {
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/components/AggregatedTable/AggregatedTable.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;AAAE;EACE,2BAAA;AAEJ;AACE;EACE,kCAAA;AACJ;AAAI;EACE,kCAAA;AAEN;AADM;EACE,iCAAA;EACA,gBAAA;AAGR;AAEE;EACE,kCAAA;EACA,iCAAA;EACA,gBAAA;EACA,gBAAA;AAAJ;AAGE;EACE,gBAAA;AADJ","sourcesContent":[".aggregated-table-root {\n  margin: 2rem 0;\n  table {\n    border: 1px solid lightgray;\n  }\n\n  tbody {\n    border-bottom: 1px solid lightgray;\n    tr {\n      border-bottom: 1px solid lightgray;\n      td {\n        border-right: 1px solid lightgray;\n        padding: 0.25rem;\n      }\n    }\n  }\n\n  th {\n    border-bottom: 1px solid lightgray;\n    border-right: 1px solid lightgray;\n    padding: 2px 4px;\n    font-weight: 700;\n  }\n\n  tfoot th {\n    text-align: left;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
